import React from 'react';

const EditIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M14.3.22a.73.73,0,0,1,1,0l4.44,4.44a.73.73,0,0,1,0,1L7.2,18.27a1.24,1.24,0,0,1-.37.22L.91,20A.73.73,0,0,1,0,19.09l1.48-5.92c0-.15.07-.22.22-.37ZM11.86,4.73l-8.95,9L1.8,18.2l4.51-1.11,9-8.95Zm1-1,1.92-1.92,3.4,3.4L16.3,7.1Z" />
  </svg>
);

export default EditIcon;
